/**
 * Compensates for the `lg:-mt-16` applied to the PageBody wrapper in Layout.
 * Applied to sections / the nav rail that must render below the sticky
 * PageHeader (i.e. everything except the `home` tab on desktop).
 */
export const STICKY_HEADER_OFFSET = 'lg:mt-16';

export const NAVIGATION_LAYOUT_CLASSES = [
	// Reset default padding from design system
	'px-0 pb-0 pt-0',
	// Medium breakpoint (768px - 1279px): 2-column span
	'md:ml-1',
	'md:w-[calc(100%+10px)]',
	// Large breakpoint (1024px - 1279px): 3-column span
	'lg:w-[calc(100%+20px)]',
	// Extra-large breakpoint (≥1280px): 3-column span
	'xl:-ml-3', // -12px left margin (extends into outer gutter)
	'xl:w-[calc(100%+36px)]', // 3 columns + 36px extension
].join(' ');
